import { render, staticRenderFns } from "./CardsCatalogo.vue?vue&type=template&id=719cb618&scoped=true"
import script from "./CardsCatalogo.vue?vue&type=script&lang=js"
export * from "./CardsCatalogo.vue?vue&type=script&lang=js"
import style0 from "./CardsCatalogo.vue?vue&type=style&index=0&id=719cb618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719cb618",
  null
  
)

export default component.exports